import * as JobTypes from "../types/jobData";
import { JobOverviewPage } from "./jobOverviewPage";
export class MapJobUi {
  private resultsContainer = (document.querySelector(".map-sidebar__results") as HTMLElement) ?? null;
  private jobOverviewPage: JobOverviewPage;

  private siteURL = window.location.origin + window.location.pathname;
  constructor(jobOverviewPage: JobOverviewPage) {
    this.jobOverviewPage = jobOverviewPage;
    this.renderJobsOnMapSidebar(this.jobOverviewPage.getFilteredJobs); // Initial render with all jobs
  }

  public renderJobsOnMapSidebar(jobs: JobTypes.jobData[]) {
    // Clear previous results
    this.resultsContainer.innerHTML = "";

    for (const job of jobs) {
      const jobCard = this.renderJobCard(job);
      this.resultsContainer.insertAdjacentHTML("beforeend", jobCard);
    }

    // console.log("Jobs on map sidebar:", jobs);
  }

  private renderJobCard(job: JobTypes.jobData): string {
    const date = job.jobOpening.earliestEntryDate
      ? job.jobOpening.earliestEntryDate
      : this.formatDateToGermanDate(job.startDate);

    return /*HTML*/ `
        <div class="job-map-card">
                    <a href="${this.siteURL}${job.id}" class="job-map-card__link-container">
                        <div class="job-map-card__start">
                            ${date}
                        </div>
                        <div class="job-map-card__title">
                            ${job.pageTitle}
                        </div>
                        <div class="job-map-card__location">
                            ${job.jobOpening.location}
                        </div>
                    </a>
                </div>
        `;
  }

  private formatDateToGermanDate(isoDate: string | null | undefined): string {
    if (!isoDate) {
      return "";
    }

    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      return ""; // Ungültiges Datum
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Monate sind 0-basiert
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }
}

function generateMapHTML() {
  //   const mapContainer = document.querySelector(".djp_map");
  //   if (!mapContainer) {
  //     console.log("No map container found");
  //     return;
  //   }
  //   mapContainer.append(/*HTML */ `
  //     <button class="container-map-list-close dt-close-button">
  //         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#272727" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  //             <line x1="18" y1="6" x2="6" y2="18"></line>
  //             <line x1="6" y1="6" x2="18" y2="18"></line>
  //         </svg>
  //     </button>
  //     <ul class="container-map-list"></ul>
  //     `);
}
